<template>
  <div class="page-column">
    <Header />
    <div class="content">
      <div class="bg" :class="stepsIndex == 1 ? 'onebg' : stepsIndex == 2 ? 'twobg' : 'threebg'">
        <div class="title">{{ bgTitle }}</div>
        <div class="des">{{ bgDes }}</div>
        <div class="steps">
          <div class="steps-item" v-for="(item, index) in stepsList" :key="index" @click="handleSteps(item)">
            <div class="number" :style="{ backgroundColor: item.id == stepsIndex ? '#be1e28' : '#999999' }">
              {{ item.id }}
            </div>
            <div class="name" :style="{ color: item.id == stepsIndex ? '#be1e28' : '#999999' }">
              <div v-for="(i, j) in item.nameList" :key="j">{{ i.name }}</div>
            </div>
            <div class="steps-line" v-if="index != stepsList.length - 1"></div>
          </div>
        </div>
      </div>
      <component :is="component"></component>
      <!-- 创办赛事 -->
      <div class="startmatch" id="start-match">
        <div class="pay-bg">
          <div class="pay">
            <div class="pay-title">开始创建你的赛事</div>
            <div class="col">
              <div class="left">
                <div class="logo">
                  <div class="name">
                    <div style="padding-top: 15px;">上传LOGO</div>
                  </div>
                  <UploadFile :size="['110px', '110px']" uploadText="点击上传" v-model="logoList" />
                </div>
              </div>
              <div class="right">
                <div class="right-row">
                  <div class="l">
                    <div class="l-name">*赛事项目</div>
                    <a-select
                      style="width: 120px;margin-right: 20px;"
                      @change="selectMatch"
                      placeholder="选择赛事"
                      size="large"
                    >
                      <a-select-option :value="item.id" v-for="(item, index) in allProgramList" :key="index">
                        {{ item.name }}
                      </a-select-option>
                    </a-select>
                    <div class="l-name">*地区选择</div>
                    <AreaChoice size="large" @change="handleAreaList" />
                  </div>
                  <div class="r">
                    <div class="r-name">*姓名</div>
                    <a-input size="large" v-model="payParams.contactName" placeholder="请输入姓名" />
                  </div>
                </div>
                <div class="right-row">
                  <div class="l">
                    <div class="l-name">*赛事名称</div>
                    <a-input
                      size="large"
                      style="width: 470px;"
                      v-model="payParams.matchName"
                      placeholder="请输入赛事名称"
                    />
                  </div>
                  <div class="r">
                    <div class="r-name">*电话</div>
                    <a-input size="large" v-model="payParams.contactPhone" placeholder="请输入电话" />
                  </div>
                </div>
              </div>
            </div>
            <div class="col">
              <div class="left">
                <div class="logo">
                  <div class="name">*赛事规程</div>
                  <UploadFile
                    uploadText="点击上传"
                    :size="['110px', '30px']"
                    listType="text"
                    :fileFormat="['doc', 'docx']"
                    :cutImg="false"
                    v-model="wordList"
                  />
                </div>
              </div>
              <!-- <div class="naming">
                <span style="margin-right: 30px;">“道吧杯”赛事冠名</span>
                <a-radio-group v-model="payParams.namedDaoba">
                  <a-radio style="color: white;" value="1">是</a-radio>
                  <a-radio style="color: white;" value="0">否</a-radio>
                </a-radio-group>
                <span style="font-size: 14px;"
                  >选择冠名，本次赛事所有费用享95折。详见
                  <a href="javascript:;" @click="agreeDetail(2)">《“道吧杯”冠名协议细则》</a></span
                >
              </div> -->
              <div class="telme">联系我们：023-68631081</div>
            </div>
            <div class="down">
              <div class="left">
                <div>请保持电话畅通，专属赛事服务专员第一时间与您联系</div>
                <div>
                  <a-checkbox style="color: white;" @change="daobaa($event, 1)">我已阅读并同意</a-checkbox>
                  <!-- @click="agreeDetail(1)" -->
                  <a href="https://static.daoba.com//347132538786.docx">《道吧网办赛协议》</a>
                </div>
                <div v-if="payParams.namedDaoba == 1">
                  <a-checkbox style="color: white;" @change="daobab($event, 2)">我已阅读并同意</a-checkbox>
                  <a href="javascript:;" @click="agreeDetail(2)">《“道吧杯”冠名协议细则》</a>
                </div>
              </div>
              <div class="right">
                <div class="price">￥{{ payPrice }}</div>
                <div class="pay-btn" @click="getmatchApply">点击支付</div>
              </div>
            </div>
          </div>
        </div>
        <div class="question">
          <div class="ques-title">常见问题</div>
          <div class="que-item">
            <div class="q">
              Q：以上所有服务支持都包含在3000元里面吗？
            </div>
            <div class="A">
              A：3000元包含专属域名官网和小程序，智能报名系统，资格审查，一键下载参赛证和秩序册等。不包含抽签编排、竞赛设备等其他服务。
            </div>
          </div>
          <!-- <div class="que-item">
            <div class="q">
              Q：怎样才能享受所有费用95折呢？
            </div>
            <div class="A">
              A：当您选择用“道吧杯”冠名，则本次所有出现赛事名称的场景，赛事名称均需包含“道吧杯”字样（含双引号）。赛事结束后，请于3个工作日内到组委会后台，冠名审核处提交视频（范例视频http：www.daoba.com/gmflsp1.mvp）。审核通过后于7个工作日内，优惠金额将返回至指定账号。
            </div>
          </div> -->
          <div class="que-item">
            <div class="q">
              Q：创建官网后能退款吗？
            </div>
            <div class="A">
              A：可以，但是退款有时间限制。在您支付后的24小时内，且专属官网还没建设好前，您可以选择无条件退款。值得注意的是，即使在支付后的24小时内，但专属官网已经建设好，则此时已不能退款，请知悉。
            </div>
          </div>
          <div class="que-item">
            <div class="q">
              Q：支持什么支付方式？提供发票吗？
            </div>
            <div class="A">
              A：目前支持微信支付。可以提供发票，个人账号提供增值税电子普通发票，企业账号提供增值税电子普通/增值税专用发票
              （港、澳、台地区除外），您下单支付成功后，在个人中心-我的订单-全部订单中申请发票即可；增值税电子普通发票24小时发送到邮箱，增值税专用发票7-30天内邮寄。
            </div>
          </div>
        </div>
      </div>
      <!-- 协议弹窗 -->
      <!-- <AgreenModal ref="agreen" :title="title" /> -->

      <a-modal
        v-model="showCode"
        title="赛事创办支付"
        :footer="null"
        :destroyOnClose="true"
        :width="500"
        @cancel="closeCode"
      >
        <div class="show-code">
          <div id="qrcode" ref="qrcode" v-if="status == 0"></div>
          <img src="@comm/assets/wepay.png" v-else style="width: 140px;height: 140px;" />
          <div class="price"><span>¥</span>{{ payCode.totalAmount }}</div>
          <div class="msg">{{ payStatusMsg }}</div>
        </div>
      </a-modal>
      <BackTop />
    </div>
    <Footer />
  </div>
</template>
<script>
import QRCode from 'qrcodejs2'
import Header from '../layout/Header.vue'
import Footer from '../layout/Footer.vue'
import BackTop from '@comm/components/public/BackTop'
import MatchCenterPc from './components/MatchCenterPc'
import MatchCenterDraw from './components/MatchCenterDraw'
import MatchCenterDevice from './components/MatchCenterDevice'
import AgreenModal from './components/AgreenModal'
import UploadFile from '@comm/upload/UploadFile'
import AreaChoice from '@comm/components/public/AreaChoice'
import { checkPhone } from '@comm/utils/DateTime'
export default {
  name: 'MatchCenter',
  components: {
    Header,
    Footer,
    BackTop,
    MatchCenterPc,
    MatchCenterDraw,
    MatchCenterDevice,
    UploadFile,
    AreaChoice,
    AgreenModal,
  },
  data() {
    return {
      stepsIndex: 1,
      stepsList: [
        {
          id: 1,
          nameList: [{ name: '官网' }, { name: '创建' }],
        },
        {
          id: 2,
          nameList: [{ name: '抽签' }, { name: '编排' }],
        },
        {
          id: 3,
          nameList: [{ name: '竞赛' }, { name: '设备' }],
        },
      ],
      component: 'MatchCenterPc',
      showCode: false,
      title: '道吧网办赛协议',
      bgTitle: '赛事+旅游+经济',
      bgDes: '一键创建赛事管理运营中心，即刻拥有专属赛事官网、独立域名、专属赛事小程序。',
      agreeA: false,
      agreeB: false,
      areaList: [],
      logoList: [],
      wordList: [],
      payParams: {
        logo: null,
        matchName: '',
        contactPhone: null,
        contactName: '',
        programId: null,
        directive: null,
        namedDaoba: 0,
        countryCode: null,
        provinceCode: null,
        cityCode: null,
        areaCode: null,
      },
      payPrice: 0,
      allProgramList: [],
      payCode: {
        oldAmount: 0.01,
        orderId: 7985,
        orderName: '赛事申请订单',
        orderNumber: '6409596e0e084dc7b2bac975427145df',
        qrCode: 'weixin://wxpay/bizpayurl?pr=o31XSNOzz',
        totalAmount: 0.01,
      },
      payStatusMsg: '请微信扫码支付',
      timer: null,
      spinning: true,
      status: 0,
    }
  },
  beforeDestroy() {
    clearInterval(this.timer)
  },
  mounted() {
    this.getAllProgram()
    this.getqueryMatchWebsiteAmount()
  },
  methods: {
    //关闭付款弹窗
    closeCode() {
      this.showCode = false
      clearInterval(this.timer)
    },
    //创建付款二维码
    qrcode() {
      let qrcode = new QRCode('qrcode', {
        width: 140,
        height: 140,
        text: this.payCode.qrCode, // 二维码地址
        colorDark: '#000',
        colorLight: '#fff',
      })
    },

    //选择地区
    handleAreaList(e) {
      this.areaList = e
      this.payParams.countryCode = e[0] ? e[0] : null
      this.payParams.provinceCode = e[1] ? e[1] : null
      this.payParams.cityCode = e[2] ? e[2] : null
      this.payParams.areaCode = e[3] ? e[3] : null
    },
    //选择赛事项目
    selectMatch(e) {
      this.payParams.programId = e
    },
    //检查支付参数
    checkPayParams() {
      if (this.logoList.length == 0) {
        this.$message.warning('请上传Logo')
        return
      }
      if (this.wordList.length == 0) {
        this.$message.warning('请上传赛事规程')
        return
      }
      if (!this.payParams.programId) {
        this.$message.warning('请选择赛事项目')
        return
      }
      if (this.areaList.length == 0) {
        this.$message.warning('请选择地区')
        return
      }
      if (!this.payParams.contactName) {
        this.$message.warning('请输入姓名')
        return
      }
      if (!this.payParams.matchName) {
        this.$message.warning('请输入赛事名称')
        return
      }

      if (!this.payParams.contactPhone) {
        this.$message.warning('手机号不能为空')
        return
      }
      if (!checkPhone(this.payParams.contactPhone)) {
        this.$message.warning('手机号码格式不正确')
        return
      }
      if (!this.agreeA) {
        this.$message.warning('请同意道吧网办赛协议')
        return
      }
      if (!this.agreeB && this.payParams.namedDaoba == 1) {
        this.$message.warning('请同意道吧杯冠名协议细则')
        return
      }
      return true
    },
    handleSteps(item) {
      this.stepsIndex = item.id
      if (item.id == 1) {
        this.bgTitle = '赛事+旅游+经济'
        this.bgDes = '一键创建赛事管理运营中心，即刻拥有专属赛事官网、独立域名、专属赛事小程序。'
        this.component = 'MatchCenterPc'
      } else if (item.id == 2) {
        this.bgTitle = '抽签编排'
        this.bgDes = '功能强大的物联网智能竞赛系统，为你的赛事赋能'
        this.component = 'MatchCenterDraw'
      } else {
        this.bgTitle = '竞赛设备'
        this.bgDes = '功能强大的物联网智能竞赛系统，为你的赛事赋能'
        this.component = 'MatchCenterDevice'
      }
    },
    daobaa(e) {
      this.agreeA = e.target.checked
    },
    daobab(e) {
      this.agreeB = e.target.checked
    },
    agreeDetail(index) {
      this.$refs.agreen.visible = true
      if (index == 1) {
        this.title = '道吧网办赛协议'
      } else {
        this.title = '“道吧杯”冠名协议细则'
      }
    },
    //获取订单状态
    async orderStatus() {
      try {
        let obj = {
          orderNo: this.payCode.orderNumber,
        }
        let res = await this.$api.match.orderStatus(obj)
        if (res.status == 0) {
          if (res.data == 1) {
            this.status = res.data
            this.payStatusMsg = '支付成功'
            this.payParams = {
              matchName: '',
              contactPhone: null,
              contactName: '',
              programId: null,
              namedDaoba: 0,
            }
            this.areaList = []
            this.logoList = []
            this.wordList = []
            clearInterval(this.timer)
          }
          res.data == 1 ? (this.payStatusMsg = '支付成功') : ''
        }
      } catch (error) {
        console.log(222, error)
      }
    },

    //获取订单
    async getmatchApply() {
      let checked = this.checkPayParams()
      if (checked) {
        this.spinning = true
        this.payParams.logo = this.logoList[0]
        this.payParams.directive = this.wordList[0]
        try {
          let res = await this.$api.match.matchApply(this.payParams)
          this.spinning = false
          if (res.status == 0) {
            this.payCode = res.data
            this.showCode = true
            this.$nextTick(() => {
              this.qrcode()
            })
            this.timer = setInterval(() => {
              this.orderStatus()
            }, 2000)
          }
        } catch (error) {}
      }
    },
    //获取支付价格
    async getqueryMatchWebsiteAmount() {
      try {
        let res = await this.$api.match.queryMatchWebsiteAmount()

        if (res.status == 0) {
          this.payPrice = Number(res.data).toLocaleString()
        }
      } catch (error) {
        console.log(222, error)
      }
    },
    //获取所有项目
    async getAllProgram() {
      try {
        let res = await this.$api.match.getAllProgram()
        if (res.status == 0) {
          this.allProgramList = res.data
        }
      } catch (error) {}
    },
  },
}
</script>
<style lang="scss" scoped>
// 对战弹窗
// /deep/ .ant-modal {
//   width: 800px !important;
// }
// /deep/ .ant-modal-content {
//   border-radius: 0 0 10px 10px !important;
// }
.page-column {
  width: 100%;
  display: flex;
  flex-direction: column;

  .content {
    width: 100%;
    position: relative;
    .bg {
      width: 100%;
      height: 450px;
      background-image: url('https://static.daoba.com/pc/matchcenter/1.png');
      background-repeat: no-repeat;
      background-size: 100% 100%;
      display: flex;
      justify-content: center;
      flex-direction: column;
      align-items: center;
      margin-top: -80px;
      color: white;
      position: relative;
      .title {
        text-align: center;
        font-size: 48px;
      }
      .des {
        font-size: 24px;
        text-align: center;
        padding-top: 10px;
      }
      .steps {
        width: 1200px;
        height: 150px;
        border-radius: 20px;
        background-color: white;
        box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.12);
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        bottom: -70px;
        box-sizing: border-box;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0 50px;
        font-size: 24px;
        color: #999999;
        .steps-item {
          display: flex;
          justify-content: space-between;
          align-items: center;
          cursor: pointer;
          .number {
            width: 60px;
            height: 60px;
            border-radius: 20px;
            line-height: 60px;
            text-align: center;
            color: white;
            background-color: #be1e28;
            font-size: 36px;
            margin-right: 20px;
            font-weight: 600;
          }
          .name {
            color: #be1e28;
            font-weight: bold;
            div:first-child {
              margin-bottom: -6px;
            }
          }
          .steps-line {
            margin-left: 80px;
            width: 200px;
            height: 2px;
            background-color: #c4c4c4;
          }
        }
      }
    }
    .onebg {
      background-image: url('https://static.daoba.com/pc/matchcenter/01.jpg');
    }
    .twobg {
      background-image: url('https://static.daoba.com/pc/matchcenter/02.jpg');
    }
    .threebg {
      background-image: url('https://static.daoba.com/pc/matchcenter/03.jpg');
    }
    .startmatch {
      width: 100%;

      .pay-bg {
        width: 100%;
        height: 570px;
        background-image: url('https://static.daoba.com/pc/matchcenter/04.jpg');
        background-repeat: no-repeat;
        background-size: 100% 100%;
        padding-top: 90px;
        .pay {
          width: 1200px;
          margin: 0 auto;
          color: white;
          .pay-title {
            font-size: 36px;
            text-align: center;
            margin-bottom: 30px;
          }
          .col {
            display: flex;
            justify-content: flex-start;
            align-items: center;
            line-height: 40px;
            .left {
              font-size: 18px;
              .logo {
                width: 280px;
                display: flex;
                justify-content: flex-start;
                box-sizing: border-box;
                .name {
                  margin-right: 20px;
                }
              }
            }
            .right {
              width: 100%;
              font-size: 18px;
              .right-row {
                display: flex;
                justify-content: space-between;
                align-items: center;
                margin-bottom: 10px;
                .l {
                  display: flex;
                  margin-right: 50px;
                  .l-name {
                    width: 100px;
                    margin-right: 10px;
                  }
                }
                .r {
                  display: flex;
                  .r-name {
                    width: 80px;
                  }
                }
              }
            }
            .naming {
              display: flex;
              justify-content: flex-start;
              align-items: center;
              font-size: 18px;
            }
            .telme {
              font-size: 18px;
            }
          }

          .down {
            display: flex;
            justify-content: space-between;
            font-size: 14px;
            border-top: 2px solid #c4c4c4;
            padding-top: 18px;
            margin-top: 30px;
            .left {
              a {
              }
            }
            .right {
              display: flex;
              justify-content: flex-end;
              align-items: center;
              .price {
                color: #be1e28;
                font-size: 50px;
              }
              .pay-btn {
                width: 180px;
                height: 60px;
                background-color: #be1e28;
                border-radius: 10px;
                text-align: center;
                line-height: 60px;
                font-size: 20px;
                margin-left: 20px;
                cursor: pointer;
              }
              .pay-btn:hover {
                opacity: 0.8;
              }
            }
          }
        }
      }

      .question {
        width: 1200px;
        height: 380px;
        margin: 0 auto;
        padding-top: 30px;
        box-sizing: border-box;
        .ques-title {
          font-size: 36px;
          font-weight: bold;
          margin-bottom: 20px;
        }
        .que-item {
          font-weight: bold;
          font-size: 14px;
          margin-bottom: 20px;
        }
      }
    }
  }
}
.show-code {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;
  .msg {
    font-size: 16px;
    font-weight: bold;
    margin-top: 10px;
  }
  .price {
    color: #be1e28;
    font-size: 20px;
    font-weight: bold;
    margin-top: 10px;
  }
  .success {
    font-size: 140px;
    color: #87cbb9;
    position: absolute;
    font-weight: bold;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
  }
}
</style>



// WEBPACK FOOTER //
// src/daoba-match/views/matchcenter/Home.vue